import Swiper, { Navigation, Pagination } from 'swiper'

export default function timeline () {
  document.addEventListener('DOMContentLoaded', () => {
    const timelines = document.querySelectorAll('.mtt-timeline')

    if (!timelines.length) {
      return
    }

    timelines.forEach((timeline) => {
      const swiperElement = timeline.querySelector('.swiper')
      const pagination = timeline.querySelector('.swiper-pagination')
      const bulletsContainer = timeline.querySelector(
        '.mtt-timeline__bullets-outer'
      )
      const bullets = timeline.querySelectorAll('.mtt-timeline__bullet')
      const prevArrows = timeline.querySelectorAll(
        '.mtt-timeline__arrow--prev'
      )
      const nextArrows = timeline.querySelectorAll(
        '.mtt-timeline__arrow--next'
      )

      if (!swiperElement) {
        return
      }

      const swiper = new Swiper(swiperElement, {
        modules: [Pagination],
        slidesPerView: 1,
        spaceBetween: 24,
        pagination: {
          el: pagination,
          type: 'progressbar',
        }
      })

      if (!bullets.length) {
        return
      }

      addNavigation(prevArrows, nextArrows, swiper)

      bullets.forEach((bullet, index) => {
        bullet.addEventListener('click', () => {
          swiper.slideTo(index)
        })
      })

      bulletsContainer.addEventListener('wheel', function (event) {
        if (isOverflowing(bulletsContainer) && event.deltaY !== 0) {
          event.preventDefault()
          bulletsContainer.scrollLeft += event.deltaY
        }
      })

      swiper.on('slideChange', function () {
        const activeBullet = document.querySelector('.mtt-timeline__bullet--active')

        if (activeBullet) {
          activeBullet.classList.remove('mtt-timeline__bullet--active')
        }

        bullets[swiper.realIndex].classList.add('mtt-timeline__bullet--active')
        bullets[swiper.realIndex].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' })
      })
    })

    addImagePopup()
  })

  function addNavigation (prevArrows, nextArrows, swiper) {
    if (!prevArrows.length || !nextArrows.length) {
      return
    }

    if (swiper.isBeginning) {
      prevArrows.forEach((prevArrow) => {
        prevArrow.classList.add('swiper-button-disabled')
      })
    }

    prevArrows.forEach((prevArrow) => {
      prevArrow.addEventListener('click', () => {
        swiper.slidePrev()
      })
    })

    nextArrows.forEach((nextArrow) => {
      nextArrow.addEventListener('click', () => {
        swiper.slideNext()
      })
    })

    swiper.on('slideChange', function () {
      prevArrows.forEach((prevArrow) => {
        if (swiper.isBeginning) {
          prevArrow.classList.add('swiper-button-disabled')
        } else {
          prevArrow.classList.remove('swiper-button-disabled')
        }
      })

      nextArrows.forEach((nextArrow) => {
        if (swiper.isEnd) {
          nextArrow.classList.add('swiper-button-disabled')
        } else {
          nextArrow.classList.remove('swiper-button-disabled')
        }
      })
    })
  }

  function isOverflowing (element) {
    return element.scrollWidth > element.clientWidth
  }

  function addImagePopup () {
    const IMAGES = document.querySelectorAll('.mtt-timeline__popup-image')
    const POPUP = document.querySelector('.mtt-timeline__popup')

    if (!IMAGES.length || !POPUP) {
      return
    }

    const POPUP_CLOSE = POPUP.querySelector('.exit')

    IMAGES.forEach((image) => {
      image.addEventListener('click', () => {
        POPUP.classList.add('active')
        POPUP.querySelector('img').src = image.src
      })
    })

    POPUP_CLOSE.addEventListener('click', () => {
      POPUP.classList.remove('active')
    })

    POPUP.addEventListener('click', (e) => {
      if (e.target === POPUP) {
        POPUP.classList.remove('active')
      }
    })

    document.addEventListener('keydown', (e) => {
      if (POPUP.classList.contains('active')) {
        if (e.key === 'Escape') {
          POPUP.classList.remove('active')
        }
      }
    })

  }
}
